import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import { COLORS } from 'theme';

const PinCompletedIcon = ({
  color = COLORS.kinetikBlack,
  size = '24px',
  sx = {},
  ...props
}) => (
  <SvgIcon sx={{ width: size, height: size, ...sx }} {...props}>
    <path
      fill={color}
      d="M12 2C8.141 2 5 5.14 5 9C5 13.068 9.63333 19.5841 11.3613 21.7031C11.6903 22.1071 12.3087 22.1071 12.6387 21.7031C14.3657 19.5841 19 13.068 19 9C19 5.14 15.859 2 12 2ZM12 4C14.757 4 17 6.243 17 9C17 11.757 14.757 14 12 14C9.243 14 7 11.757 7 9C7 6.243 9.243 4 12 4Z"
    />
    <path
      fill={color}
      stroke={color}
      strokeWidth="0.417"
      d="M14.1976 7.00013C14.1213 7.0024 14.0489 7.03429 13.9957 7.08904L10.9727 10.112L10.0056 9.14489C9.97854 9.11671 9.94612 9.0942 9.91025 9.0787C9.87439 9.0632 9.83578 9.05501 9.79671 9.05461C9.75764 9.05421 9.71888 9.06162 9.6827 9.07639C9.64653 9.09116 9.61366 9.113 9.58603 9.14063C9.5584 9.16826 9.53656 9.20112 9.52179 9.2373C9.50702 9.27347 9.49962 9.31223 9.50002 9.35131C9.50041 9.39038 9.5086 9.42898 9.52411 9.46485C9.53961 9.50072 9.56211 9.53313 9.5903 9.5602L10.7651 10.735C10.8202 10.79 10.8948 10.821 10.9727 10.821C11.0506 10.821 11.1253 10.79 11.1804 10.735L14.411 7.50434C14.4534 7.46309 14.4824 7.40998 14.4942 7.35197C14.5059 7.29395 14.4998 7.23375 14.4768 7.17925C14.4537 7.12474 14.4147 7.07848 14.3649 7.04651C14.3151 7.01455 14.2568 6.99838 14.1976 7.00013Z"
    />
  </SvgIcon>
);

PinCompletedIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
  sx: PropTypes.object,
};

export default PinCompletedIcon;
